import { utilizationAndCoverageDetailsSelector } from "./utilizationAndCoverageDetailsSelector";
import { RootState } from "../../../../../store";
import { SavingsPlanFilteredData } from "../../../../../../services/cloudchipr.api";

export const utilizationAndCoverageDetailsDataSelector = (
  state: RootState,
): SavingsPlanFilteredData | undefined => {
  return utilizationAndCoverageDetailsSelector(state)?.data;
};
